<template>
  <b-container>
    <b-row>
      <b-col md="6">
        <h1>Company File Type</h1>

        <b-form inline @submit.prevent="saveType">
          <b-form-input v-model="fileType" placeholder="Name" class="mr-2"/>
          <b-button variant="outline-secondary" @click="cancelEdit" class="mr-2" v-if="editItem !== null">Cancel</b-button>
          <b-button variant="primary" type="submit">{{ editItem === null ? 'Add' : 'Save' }}</b-button>
        </b-form>
        
        <b-table-lite class="mt-2" :fields="fields" :items="types">
          <template v-slot:cell(actions)="data">
            <div class="float-right">
            <b-button size="sm" variant="outline-secondary" class="mr-2" @click="editType(data.item)">
              <b-icon-card-text></b-icon-card-text>
            </b-button>
            <b-button size="sm" variant="outline-secondary" @click="showDeleteDialog(data.item)"><b-icon-trash></b-icon-trash></b-button>
            </div>
          </template>
        </b-table-lite>
      </b-col>
    </b-row>

    <b-modal 
      title="Confirm Delete" 
      v-model="deleteDialog"
      ok-variant="danger"
      cancel-variant="outline-secondary"
      ok-title="Delete"
      @ok="deleteType"
    >
      <p>Delete file type?</p>
    </b-modal>
  </b-container>
</template>

<script>
import axios from 'axios';

export default {
  data() {
    return {
      fields: ['name', { key: 'actions', label: '' }],
      fileType: '',
      types: [],
      deleteDialog: false,
      deleteItem: null,
      editItem: null
    }
  },
  methods: {
    saveType() {
      if (this.fileType === '') return;

      if (this.editItem === null) {
        axios.post('/api/companydoctypes', { name: this.fileType }).then(res => {
          this.types.push(res.data);
          this.fileType = '';
        });
      } else {
        axios.put(`/api/companydoctypes/${this.editItem.id}`, { 
          id: this.editItem.id,
          name: this.fileType 
        }).then(() => {
          const index = this.types.findIndex(t => { return t.id === this.editItem.id });

          if (index > -1) {
            this.types[index].name = this.fileType;
            this.editItem = null;
            this.fileType = '';
          }
        });
      }
    },
    deleteType() {
      axios.delete(`/api/companydoctypes/${this.deleteItem.id}`)
      .then(() => {
        const index = this.types.indexOf(this.deleteItem);
        
        if (index > -1) {
          this.types.splice(index, 1);
          this.deleteItem = null;
        }
      })
    },
    showDeleteDialog(item) {
      this.deleteItem = item;
      this.deleteDialog = true;
    },
    editType(item) {
      this.editItem = item;
      this.fileType = item.name;
    },
    cancelEdit() {
      this.editItem = null;
      this.fileType = '';
    }
  },
  created() {
    axios.get('/api/companydoctypes').then(res => this.types = res.data);
  }
}
</script>